// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Layout":"Layout-4f2n6954yp2krfkpbjv63aas1uy5bw3qkdegp6u26hhuk3zwcx676f2edvagjyuxpbchwdnaezc3324g9fu8me4manavecvgr9vb3ng","Wrapper":"Wrapper-2wfvtnfuagzwpewnzc87w6nh2pwkbq5awj6bzh3h4pvg38g7vnysec2217scb8muv17wh8z7yhgt1ff4xr32bmabu5j9pad5qnzavhw","loading":"loading-2banjg3446dzqce95fg2asgrmt5p2113u9bn2tu3k6a61jjt6ku3k4vgn2u6e9rdq5vp943uvahn18b12x2yb3k2a33uzj7p66zkwbu","pulse":"pulse-3d1w8g4uv45dp5nebfzz8dz4pqp6znedstqgzwr9g2e49bf315knvnp4haukwc7pbx3g9r6dc9bgw5uevzcemc6gygep8x724yxkmes"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/Layout.module.scss
// module id = 760
// module chunks = 0